export default "__VITE_ASSET__avWC_tp1__"